"use strict";
{
const swatches = () => {

    const globalColorSwatches = document.getElementById('colorSwatchesData') ? JSON.parse(document.getElementById('colorSwatchesData').innerText) : null;
    const storedProductSkusInSession = JSON.parse(sessionStorage.getItem("productSkus_v2"));

    class ColorSwatches {
        constructor({ globalColorSwatches, globalLinkedProducts, elem }) {

            this.dom = {
                swatches: elem,
                label: elem.querySelector('[data-color-swatches-label]')
            }
            this.options = {}

            this.options = this.getSkuAndColor();
            this.options.id = elem.dataset.productId ? elem.dataset.productId : null
            this.options.type = elem.dataset.swatchesType ? elem.dataset.swatchesType : null
            this.options.currentColor = {
                color: elem.dataset.productColor ? elem.dataset.productColor : null,
                colorName: elem.dataset.productColorName ? elem.dataset.productColorName : null
            };



            /* If keep is true - keep the swatch selected */
            this.options.keep = false;
            this.options.isProductCard = false;

            switch (this.options.type) {
                case 'product-card':
                    this.options.swatchLimit = 8;
                    this.options.isProductCard = true;
                    break;

                default:
                    this.options.swatchLimit = 0;
                    break;
            }

            this.colors = globalColorSwatches;

            this.linkedProducts = this.getLinkedProducts({ jsonProductData: globalLinkedProducts });

            this.dom.swatches.removeAttribute('data-swatches-template');

            if (this.linkedProducts === undefined || this.linkedProducts.length <= 1) return this.dom.swatches.remove();

            this.init()
        }


init() {
    const fragment = new DocumentFragment();
    const itemElement = this.dom.swatches.querySelector('.js-color-Swatches__item');
    const itemListElement = this.dom.swatches.querySelector('.js-color-Swatches__list');

    if (!!this.dom.label && this.dom.itemListElement) {
        this.dom.label.innerText = !!this.options.currentColor.colorName ? this.options.currentColor.colorName : this.options.currentColor.color;
        this.dom.itemListElement = itemListElement;
    }

    let filteredProducts = this.linkedProducts;
    const modelType = this.dom.swatches.dataset.productModelType;
    const taggedSoleType = this.dom.swatches.dataset.productSoleType;

    filteredProducts = filteredProducts.filter(item =>
        (!modelType || item.modelType === modelType) &&
        (!taggedSoleType || item.soleType === taggedSoleType)
    );

    // Detect sole type from current product URL (recommended) or title (fallback)
    let soleType = '';
    const currentUrl = window.location.pathname.toLowerCase();
    if (currentUrl.includes('sole-black')) {
        soleType = 'sole-black';
    } else if (currentUrl.includes('sole-honey')) {
        soleType = 'sole-honey';
    } else if (currentUrl.includes('sole-rubber')) {
        soleType = 'sole-rubber';
    } else {
        // fallback to title if needed
        const currentTitle = this.dom.swatches.dataset.productTitle
            ? this.dom.swatches.dataset.productTitle.toLowerCase()
            : '';
        if (currentTitle.includes('black')) {
            soleType = 'sole-black';
        } else if (currentTitle.includes('honey')) {
            soleType = 'sole-honey';
        } else if (currentTitle.includes('rubber')) {
            soleType = 'sole-rubber';
        }
    }

    // Filter swatches by sole type in URL
    if (!taggedSoleType && soleType) {
        filteredProducts = filteredProducts.filter(item => item.url && item.url.toLowerCase().includes(soleType));
    }

    // Remove duplicate color swatches (keep first occurrence)
    const seenColors = new Set();
    filteredProducts = filteredProducts.filter(item => {
        const colorKey = item.colorName ? item.colorName.toLowerCase() : '';
        if (seenColors.has(colorKey)) {
            return false;
        }
        seenColors.add(colorKey);
        return true;
    });

    if (filteredProducts.length > 0) {
        filteredProducts.slice(-(Number(this.options.swatchLimit))).forEach((item) => {
            const template = itemElement.cloneNode(true);
            this.swatch_setup({ item: item, template: template });
            fragment.appendChild(template);
        });

        if (this.options.swatchLimit !== 0 && filteredProducts.length > this.options.swatchLimit) {
            const plusIconContainer = itemElement.cloneNode(true);
            const plusIcon = document.createElement('div');
            plusIconContainer.innerHTML = '';
            plusIcon.innerText = `+ ${filteredProducts.length - this.options.swatchLimit}`;
            plusIconContainer.classList.add('plus-icon__container');
            plusIconContainer.appendChild(plusIcon);
            fragment.appendChild(plusIconContainer);
        }

        itemListElement.innerHTML = '';
        itemListElement.appendChild(fragment);
    } else {
        itemListElement.innerHTML = '';
    }
}

        swatch_setup({ item, template }) {
            this.swatch_changeColorTitle({ item, template });
            this.swatch_addColorOrImage({ item, template });

            if (this.options.isProductCard) {
                this.swatch_changeProductCardImage({ item, template })
            }

        }

        swatch_addColorOrImage({ item, template }) {
            let globalSwatchValue = null;

            if (!item.showSwatchAsImage && item.colorName) {
                template.querySelector('.js-color-swatch__url').setAttribute('title', capitalize(item.colorName));
            }

            /** Get global swatch value from theme swatch colors */
            if (!item.showSwatchAsImage && globalColorSwatches[item.colorName.toLowerCase()] != undefined) {
                globalSwatchValue = globalColorSwatches[item.colorName.toLowerCase()];
            }

            /**Hex code or image */
            if (!item.showSwatchAsImage && globalSwatchValue && globalSwatchValue.charAt(0) === '#') {
                template.querySelector('.js-color-Swatches__swatch').style.backgroundColor = globalSwatchValue;
                template.querySelector('.js-color-Swatches__swatch img').remove();
            }
            else {
                const itemImage = globalSwatchValue ? globalSwatchValue : item.image;

                if (itemImage) {



                    /***
                     * Include this in theme {{ 'option_selection.js' | shopify_asset_url | script_tag }}
                     */

                    const imageUrl = Shopify.Image.getSizedImageUrl(itemImage, '100x100');

                    template.querySelector('.js-color-Swatches__swatch img').setAttribute('src', imageUrl);

                    /***
                     * Preloads image, so it is displayed faster
                     */
                    (new Image(100, 100)).src = imageUrl;
                }
            }
        }

        swatch_changeColorTitle({ item, template }) {
            const swatchLink = template.querySelector('.js-color-swatch__url');
            const colorLabel = item.colorName || item.color || '';
            const isCurrentColor = this.options.currentColor.color === item.color;

            if (colorLabel) {
                swatchLink.setAttribute('aria-label', colorLabel);
            }

            /**
             * Set default selected swatch
             */
            if (isCurrentColor) {
                template.classList.add('is-selected');
                swatchLink.setAttribute('aria-current', 'page');
            } else {
                swatchLink.removeAttribute('aria-current');
            }

            /**
             * Set url for the linked product
             */


            // Get current market prefix from the pathname (e.g. '/en-dk/')
// const marketPrefix = window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\//);
// const prefix = marketPrefix ? marketPrefix[0] : '/';

// // Prepend market prefix to the swatch URL if not already present
// let swatchUrl = item.url;
// if (marketPrefix && !swatchUrl.startsWith(marketPrefix[0])) {
//   swatchUrl = marketPrefix[0] + swatchUrl.replace(/^\//, '');
// }
// template.querySelector('.js-boost-pfs-filter-option-item-list.boost-pfs-filter-option-item>button:hover').setAttribute('href', swatchUrl);



            // Preserve market prefix in the swatch URL if present
            const marketPrefixMatch = window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\//);
            let swatchUrl = item.url;
            if (marketPrefixMatch && !swatchUrl.startsWith(marketPrefixMatch[0])) {
                swatchUrl = marketPrefixMatch[0] + swatchUrl.replace(/^\//, '');
            }
            swatchLink.setAttribute('href', swatchUrl);

            /**
             * Change color text on hover
             */
            template.addEventListener('mouseenter', () => {

                this.dom.label.innerText = !!item.colorName && !item.showSwatchAsImage ? item.colorName : item.color;

                /**
                 * if keep is true - keep the swatch selected
                 */
                if (this.options.keep === true) {

                    this.dom.itemListElement.querySelectorAll('.js-color-Swatches__item').forEach(elem => {
                        elem.classList.remove('is-selected')
                    });

                    template.classList.add('is-selected')
                } else {
                    //If keep = false, then set color title = original color
                    template.addEventListener('mouseleave', () => {
                        this.dom.label.innerText = !!this.options.currentColor.colorName && !item.showSwatchAsImage ? this.options.currentColor.colorName : this.options.currentColor.color;
                    })
                }
            })
        }

        swatch_changeProductCardImage({ item, template }) {


            const productCollectionCardObj = { dom: {} };
            productCollectionCardObj.dom.main = document.getElementById(this.options.id);
            productCollectionCardObj.dom.title = productCollectionCardObj.dom.main.querySelector('.ProductItem__Title a');
            productCollectionCardObj.dom.imageContainer = productCollectionCardObj.dom.main.querySelector('.ProductItem__ImageWrapper .AspectRatio');


            if (!productCollectionCardObj.dom.main) return this.dom.swatches.remove();


            if (productCollectionCardObj && this.options.currentColorObj.text !== item.colorName) {

                const imageElem = document.createElement('img');

                imageElem.setAttribute('data-src', item.image);
                imageElem.setAttribute('data-widths', item.imageSupportedSizes);
                imageElem.setAttribute('data-sizes', 'auto');
                imageElem.classList.add('swatch-image', 'Image--lazyLoad');
                imageElem.style.display = 'none';

                imageElem.draggable = false;

                productCollectionCardObj.dom.imageContainer.appendChild(imageElem);

                template.addEventListener('mouseenter', () => {

                    imageElem.style.display = 'block';

                    const selectedSwatchImages = productCollectionCardObj.dom.imageContainer.querySelectorAll('.swatch-image.is-selected')

                    selectedSwatchImages.forEach(selectedSwatchImage => {
                        selectedSwatchImage.remove('is-selected');
                    });

                    imageElem.classList.add('is-selected');
                })

                if (this.options.keep !== true) {
                    template.addEventListener('mouseleave', () => {
                        imageElem.classList.remove('is-selected');

                    })
                }
            }
            else if (productCollectionCardObj && this.options.currentColor.colorName === item.color) {
                template.addEventListener('mouseenter', () => {
                    productCollectionCardObj.dom.swatchImage.style.display = 'none'
                })
            }
        }

        getSkuAndColor() {
            const productSku = this.dom.swatches.dataset.productSku;
            const productColor = this.dom.swatches.dataset.productColor;

            /** first item in the array is the sku */
            /** secound item in the array is the colour name */

            /**
             * Gives => 
             * this.options.sku
             * this.optins.color
             */

            return { "sku": productSku, "color": productColor }
        }

        getLinkedProducts({ jsonProductData }) {
            if (jsonProductData) {
                return jsonProductData[this.options.sku];
            }
            else {
                console.warn('no jsonProductData');
                return null;
            }
        }
    }

    class ColorSwatchesData {
        constructor() {
            this.options = {}
            this.data = {}
            this.init();
        }

        async init() {
            try {
                await this.getUrlFetchLimit();
                await this.getRequestUrls();
                await this.getProducts();
                await this.saveToSesseion();

            }
            catch (e) {
                console.error(e);
            }

            initSwatches({ globalLinkedProducts: this.data });
            // reInitSwatchesAfterEvent({ globalLinkedProducts: this.data });
        }

        async getUrlFetchLimit() {
            return fetch('/collections/all?view=swatch-data-limit')
                .then(response => {
                    const limit = response.json()
                    this.options.urlLimit = limit;
                }).catch(e => {
                    console.error(e);
                });
        }

        async getRequestUrls() {
            return new Promise((resolve) => {
                const requestUrls = []
                /**Get all available urls */
                if (this.options.urlLimit > 0) {
                    for (let i = 1; i < (parseInt(Object.values(this.options.urlLimit)) + 1); i++) {
                        const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ i }`).then((response) => response.json());
                        requestUrls.push(urlFetch)
                    }
                }
                else {
                    const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ 1 }`).then((response) => response.json());
                    requestUrls.push(urlFetch)
                }
                this.options.requestUrls = requestUrls;
                resolve()
            })
        }

        async getProducts() {
            const _this = this;
            return Promise.all(this.options.requestUrls).then((data) => {
                // Log the data to the console
                // You would do something with both sets of data here
                const merged = [].concat.apply([], data);
                /**Group the products so they are easier to find */
                const groupedProducts = groupBy(merged, 'sku');

                _this.data = groupedProducts;
            }).catch((e) => {
                // if there's an error, log it
                console.error(e);
            });
        }

        async saveToSesseion() {
            const mySession = window.sessionStorage;
            mySession.setItem("productSkus_v2", JSON.stringify(this.data));
        }
    }



    const initSwatches = ({ globalLinkedProducts }) => {
        const swatches = document.querySelectorAll('[data-swatches-template]');

        swatches.forEach(swatch => {
            void new ColorSwatches({ globalColorSwatches: globalColorSwatches, globalLinkedProducts, elem: swatch });
        });

    }

    // const reInitSwatchesAfterEvent = ({ globalLinkedProducts }) => {
    //     document.addEventListener('slick.afterChange', () => {
    //         initSwatches({ globalLinkedProducts });
    //     })
    //     document.addEventListener('filter.loadContent', () => {
    //         initSwatches({ globalLinkedProducts });
    //     })
    // }


    /**
     * Checking if storedProductSkusInSession exist, and is not an empty object
     */

    if (storedProductSkusInSession && JSON.stringify(storedProductSkusInSession) !== '{}') {
        //if swatches data init swatches
        initSwatches({ globalLinkedProducts: storedProductSkusInSession });
        // reInitSwatchesAfterEvent({ globalLinkedProducts: storedProductSkusInSession });
    }
    else {
        //Get swatches data from custom endpoint
        void new ColorSwatchesData();
    }
}

const tagSwatches = () => {

    class TagSwatches {
        constructor({ elem }) {

            this.dom = {
                template: elem,
                swatches: elem.querySelectorAll('[data-color-name]'),
                label: elem.querySelector('[data-color-swatches-label]'),
            }

            this.options = {}

            this.options.keep = false

            this.options.currentColor = {
                colorName: this.dom.label.dataset.colorSwatchesCurrentColor ? this.dom.label.dataset.colorSwatchesCurrentColor : null
            };

            this.init()
        }


        init() {

            this.dom.swatches.forEach(swatch => {
                this.swatch_changeColorTitle({ item: swatch });
            });
        }


        swatch_changeColorTitle({ item }) {

            /**
             * Change color text on hover
             */
            item.addEventListener('mouseenter', () => {

                this.dom.label.innerText = !!item.dataset.colorName ? item.dataset.colorName : item.dataset.color;

                /**
                 * if keep is true - keep the swatch selected
                 */
                if (this.options.keep === true) {

                    this.dom.itemListElement.querySelectorAll('.js-color-Swatches__item').forEach(elem => {
                        elem.classList.remove('is-selected')
                    });

                    item.classList.add('is-selected')
                } else {
                    //If keep = false, then set color title = original color
                    item.addEventListener('mouseleave', () => {
                        this.dom.label.innerText = !!this.options.currentColor.colorName ? this.options.currentColor.colorName : this.options.currentColor.color;
                    })
                }
            })
        }
    }


    const tagSwatchesTemplates = document.querySelectorAll('[data-tag-swatches-template]');
    tagSwatchesTemplates.forEach((tagSwatchesTemplate) => {
        void new TagSwatches({ elem: tagSwatchesTemplate });
    });


}

const whenReady = () => {
    tagSwatches();
    swatches();

    document.addEventListener('ColorSwatchesData:reload', () => {
        debugger
        void new ColorSwatchesData();
    })
    
}

setTimeout(() => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        whenReady();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            whenReady();
        }, {
            once: true,
        });
    }
}, 0);





/****
 * 
 * Helpers
 * 
 */

const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}


const groupBy = (data, ...keys) => {
    // Takes an array of objects and the property by which they should be grouped.
    // Produces an object of arrays keyed by the specified property values.
    // 
    // Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
    // 
    // Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
    //     =>
    //     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}

    // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
    const getGroupFromItem = (item, keys) => {
        return (keys.length > 1)
            ? getGroupFromItem(item[keys[0]], keys.slice(1))
            : item[keys[0]]
    }

    return data.reduce((results, item) => {
        // Get the first instance of the key by which we're grouping
        var group = getGroupFromItem(item, keys);

        // Ensure that there's an array to hold our results for this group
        results[group] = results[group] || [];

        // Add this item to the appropriate group within results
        results[group].push(item);

        // Return the updated results object to be passed into next reduce call
        return results;
    },
        // Initial value of the results object
        {}
    );
};
}

